<template>
  <d-tabs v-model="selectedGroup" ref="tabs" class="groups-tab">
    <d-tab :title="group.name" class="p-3" v-for="(group, index) in model" :key="index">
      <d-row>
        <!-- Nome -->
        <d-col md="8" class="form-group">
          <label for="name">
            Etiqueta
          </label>
          <d-form-input
            type="text"
            id="fename"
            placeholder="Nome"
            :state="hasError(group, 'name')"
            v-model="group.name"
          />
          <d-form-invalid-feedback>Etiqueta é obrigatório</d-form-invalid-feedback>
        </d-col>
        <d-col md="4" class="form-group text-right d-flex justify-content-end align-items-end">
          <label class="d-block p-2"></label>
          <d-button-group class="buttons">
            <d-button type="button" size="sm" class="btn-success" @click.prevent="addTab()">
              <i class="fas fa-plus"></i><span class="d-none d-lg-inline"> Adicionar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-secondary" @click.prevent="duplicateTab(index)">
              <i class="fas fa-copy"></i><span class="d-none d-lg-inline"> Duplicar Aba</span>
            </d-button>
            <d-button type="button" size="sm" class="btn-danger" @click.prevent="confirmDeleteTab(index)" v-if="model.length > 1">
              <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar Aba</span>
            </d-button>
          </d-button-group>
        </d-col>
      </d-row>

      <!-- Product Table -->
      <d-form-row class="mt-4 mb-4 justify-content-end">
        <table class="table table-striped table-bordered" role="table">
          <thead class="bg-light" role="rowgroup">
            <tr role="row">
              <th role="columnheader" class="text-center">ID</th>
              <th role="columnheader">Produto</th>
              <th role="columnheader" class="text-center">Qtd.</th>
              <th role="columnheader" class="text-right"></th>
            </tr>
          </thead>
          <draggable
            v-model="group.rows"
            tag="tbody"
            ghost-class="ghost"
            draggable=".draggable-item"
            @end="setProductInAutocomplete"
          >
            <tr
              role="row"
              v-for="(item, navItemId) in group.rows"
              :key="navItemId"
              class="drag-row draggable-item"
            >
              <td role="cell" class="td-1">
                <span class="d-block mt-2 text-center">{{navItemId + 1}}</span>
              </td>
              <td role="cell" class="td-4">
                <autocomplete
                  :ref="`autocompleteProduct_${index}${navItemId}`"
                  :state="hasError(item, 'variation_id')"
                  placeholder="Produto"
                  :items="products"
                  item-show="name"
                  :parameter="{item, index, navItemId}"
                  :on-input="onInputProduct"
                  :on-select="setProductTemplateRow"
                  :on-blur="onAutocompleteBlur"
                ></autocomplete>
                <d-form-invalid-feedback>Selecionar um produto é obrigatório</d-form-invalid-feedback>
              </td>
              <td role="cell" class="td-2">
                <input
                  type="number"
                  class="text-center form-control"
                  :step="item.step"
                  placeholder="Qtd."
                  v-model="item.quantity"
                  required
                />
              </td>
              <td role="cell" class="td-1 buttons">
                <i class="fas fa-minus text-danger" @click="removeRow(index, navItemId)" v-if="group.rows.length > 1"></i>
              </td>
            </tr>
          </draggable>
        </table>
        <button type="button" @click="addRow(index)" class="btn btn-success"><i class="fas fa-plus text-white"></i> Novo item</button>
      </d-form-row>

      <payment-methods :group.sync="group" :state="state" :index="index" />

      <d-form-row>
        <!-- Obrigações contratante -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <label for="feComentarios" class="d-flex justify-content-between">
            Obrigações contratante
            <button @click="openObligation('contractor', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratante</button>
          </label>
          <editor :model.sync="group.obligations_buyer" />
        </d-col>

        <!-- Obrigações contratado -->
        <d-col md="6" lg="6" cols="12" class="form-group">
          <label for="feObligations" class="d-flex justify-content-between">
            Obrigações contratado
            <button @click="openObligation('hired', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Obrigações Contratado</button>
          </label>
          <editor :model.sync="group.obligations_seller"/>
        </d-col>

      </d-form-row>

      <d-form-row>
        <!-- Itens Inclusos -->
        <d-col cols="12" class="form-group">
          <label for="feComentarios" class="d-flex justify-content-between">
            Itens Inclusos
            <button @click="openObligation('itemsIncluded', index)" type="button" class="btn-primary btn-sm py-1 btn-sm">Itens Inclusos</button>
          </label>
          <editor :model.sync="group.items_included" />
        </d-col>
      </d-form-row>
    </d-tab>
  </d-tabs>
</template>

<script>
import draggable from 'vuedraggable';
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import Editor from '_shared/Editor.vue';
import Autocomplete from '_shared/Autocomplete.vue';
import InputCurrency from '_common/shared/InputCurrency.vue';
import InputWarranty from '_common/shared/InputWarranty.vue';
import GroupActions from './GroupActions';
import {
  _DELETE_TAB_,
  TEMPLATE_GROUP,
  TEMPLATE_ROW,
  _LOAD_TEMPLATE_MODEL_,
  _OPEN_OBLIGATION_MODAL_,
  _SET_OBLIGATION_IN_QUOTATION_,
  OBLIGATION_FIELDS,
} from './QuotationModel';
import PaymentMethods from './PaymentMethods.vue';

export default {
  name: 'template-groups-form',
  mixins: [GroupActions],
  components: {
    Editor,
    draggable,
    Autocomplete,
    PaymentMethods,
    InputCurrency,
    InputWarranty,
  },
  props: {
    groups: {
      type: Array,
      default() { return [cloneDeep(TEMPLATE_GROUP)]; },
    },
    state: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedGroup: 0,
      errors: {
        name: { required: false },
      },
    };
  },
  computed: {
    model: {
      get() {
        return this.groups;
      },
      set(value) {
        this.$emit('update:groups', value);
      },
    },
    products() {
      const { productVariationsList } = this.$store.state.product;
      if (productVariationsList && productVariationsList.list.length) {
        return productVariationsList.list;
      }
      return [];
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'getProductVariations',
    ]),
    addRow(index) {
      this.addGroupRow(TEMPLATE_ROW, index);
    },
    removeRow(groupIndex, index) {
      this.removeGroupRow(groupIndex, index);
      setTimeout(() => {
        this.setProductInAutocomplete();
      }, 50);
    },
    addTab() {
      this.addGroupTab(TEMPLATE_GROUP, 'Novo Grupo');
    },
    setProductTemplateRow(product, { item }) {
      item.variation_id = product.id;
      item.variation = product;
    },
    onAutocompleteBlur(_, { item, index, navItemId }) {
      setTimeout(() => {
        if (!item.variation_id) {
          if (this.$refs[`autocompleteProduct_${index}${navItemId}`][0]) {
            this.$refs[`autocompleteProduct_${index}${navItemId}`][0].$refs.input.value = null;
          }
          this.activeAlert({ message: 'Você deve selecionar um produto', theme: 'danger' });
        }
      }, 200);
    },
    setProductInAutocomplete() {
      setTimeout(() => {
        this.model.map((group, index) => (
          group.rows.map((row, navItemId) => {
            if (this.$refs[`autocompleteProduct_${index}${navItemId}`][0] &&
                row.variation_id &&
                row.variation.name
            ) {
              this.$refs[`autocompleteProduct_${index}${navItemId}`][0].$refs.input.value = row.variation.name;
            } else {
              this.$refs[`autocompleteProduct_${index}${navItemId}`][0].$refs.input.value = '';
            }
            return row;
          })
        ));
      }, 20);
    },
    openObligation(type, index) {
      this.setToggle({ type: 'add_obligations_modal', bool: true });
      Events.$emit(_OPEN_OBLIGATION_MODAL_, {
        type,
        index,
        html: this.model[index][OBLIGATION_FIELDS[type]],
      });
    },
    getOptions() {
      this.getObligationOptions();
    },
    checkRequiredFields() {
      const hasError = this.model.some(group => {
        const nameEmpty = !group.name || !group.name.trim();
        this.$set(group, 'errors', { name: { required: nameEmpty } });

        const rowInvalid = group.rows.some(row => {
          const invalid = row.variation_id == null || row.variation_id === undefined;
          this.$set(row, 'errors', { variation_id: { required: invalid } });
          return invalid;
        });
        return nameEmpty || rowInvalid;
      });

      return !hasError;
    },
    validateAll() {
      return this.checkRequiredFields();
    },
  },
  destroyed() {
    Events.$off(_LOAD_TEMPLATE_MODEL_);
    Events.$off(_DELETE_TAB_);
    Events.$off(_SET_OBLIGATION_IN_QUOTATION_);
  },
  mounted() {
    this.getOptions();
    this.loadModel();
    Events.$on(_LOAD_TEMPLATE_MODEL_, newValue => {
      this.model = [...newValue.groups];
      this.loadModel();
    });
    Events.$on(_DELETE_TAB_, index => {
      this.deleteTab(index);
    });
    Events.$on(_SET_OBLIGATION_IN_QUOTATION_, ({ obligation, type, index }) => {
      this.model[index][OBLIGATION_FIELDS[type]] = obligation;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  cursor: pointer;
  color: $primary;
  font-size: 0.7rem;
  margin-left: 10px;
  &:hover {
    text-decoration: underline;
  }
}
.groups-tab /deep/ .nav-tabs {
  border-bottom: 0!important;
}
.tab-pane {
  border: 1px solid #e1e5eb;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.td {
  &-1 {
    width: 4%;
  }
  &-2 {
    width: 10%;
    min-width: 75px;
  }
  &-3 {
    width: 15%;
  }
  &-4 {
    width: 35%;
  }
}
.buttons {
  text-align: center;
  vertical-align: bottom;
  .btn-sm { padding: 0.4rem 0.7rem; }
  i { cursor: pointer; }
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

@media only screen
  and (max-width: 760px), (min-device-width: 768px)
  and (max-device-width: 1024px)  {

  /* Force table to not be like tables anymore */
  table, thead, tbody, th, td, tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  tr {
    margin: 0;
    &:nth-child(odd) {
      background: #ccc;
    }
  }

  td {
    /* Behave  like a "row" */
    border: none;
    border-bottom: 1px solid #eee;
    position: relative;
    vertical-align: middle;
    padding-top: 30px;
    &:first-child {
      text-align: center;
      padding: 3px 3px 9px 3px;
      &:before {
        position: absolute;
        top: 10px;
        left: 116px;
        width: 5%;
        padding-right: 10px;
        white-space: nowrap;
      }
    }
    &:before {
      /* Now like a table header */
      position: absolute;
      /* Top/left values mimic padding */
      top: 5px;
      left: 6px;
      width: 5%;
      padding-right: 10px;
      white-space: nowrap;
    }
    &.td-1,
    &.td-2,
    &.td-3,
    &.td-4 {
      width: 100%;
    }
    &.buttons {
      i {
        padding: 10px;
        color: #fff !important;
        border-radius: 5px;
        &.fa-minus{
          border: 1px solid #c4183c;
          background: #dc3545;
        }
        &.fa-plus {
          margin-right: 5px;
          border: 1px solid #28a745;
          background: #17c671;
        }

      }
    }
  }

  /*
  Label the data
  You could also use a data-* attribute and content for this. That way "bloats" the HTML, this way means you need to keep HTML and CSS in sync. Lea Verou has a clever way to handle with text-shadow.
  */
  td:nth-of-type(1):before { content: "ID"; }
  td:nth-of-type(2):before { content: "Descrição produto"; }
  td:nth-of-type(3):before { content: "Garantia"; }
  td:nth-of-type(4):before { content: "Qtd."; }
  td:nth-of-type(5):before { content: "Valor un."; }
  td:nth-of-type(6):before { content: "Op\00e7\00f5""es"; }
}

</style>
